export default "__VITE_ASSET__Dvs90ytW__"